document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.scroll-trigger.animate--fade-in');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(el => observer.observe(el));
});